import { defineMessages } from "react-intl";

export const messages = defineMessages({
  tooltip: {
    id: "button.contactAction.tooltip",
    defaultMessage: "More",
    description: "More actions label",
  },
});
